import * as React from 'react';
import Animated, { interpolateColor, useDerivedValue } from 'react-native-reanimated';
import { rem } from 'design-system';
import { StyleSheet } from 'react-native';
import useColors from 'hooks/useColors';
const source = require('../img/gradientCover.png');
const IconCover = ({ scrollY }) => {
    const colors = useColors();
    const [tintColor, setTintColor] = React.useState(colors.background.dark);
    useDerivedValue(() => {
        const newTintColor = interpolateColor(scrollY.value, [0, 40], [
            colors.background.dark,
            colors.cards.onDark,
        ]);
        setTintColor(newTintColor);
    }, [colors.background.dark, colors.cards.onDark, scrollY]);
    return <Animated.Image source={source} tintColor={tintColor} style={styles.container}/>;
};
const styles = StyleSheet.create({
    container: {
        width: rem(24),
        height: rem(16),
    },
});
export default IconCover;
